import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {
    NavigationCancel,
    NavigationEnd,
    NavigationError,
    NavigationStart,
    Router,
} from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { Subject, takeUntil } from 'rxjs';

/** Routes that should not show the top progress bar (auth / public). */
const SKIP_SEGMENTS = new Set([
    'sign-in',
    'sign-out',
    'sign-up',
    'home',
    'otp',
    'forgot-password',
    'reset-password',
    'change-password',
    'chat-with-agent',
    'external-custom-agents',
]);

function shouldShowLoader(url: string): boolean {
    const segments = url.split('?')[0].split('/').filter(Boolean);
    if (segments.length === 0) {
        return false;
    }
    return !segments.some(seg => SKIP_SEGMENTS.has(seg));
}

@Component({
    selector   : 'route-loader',
    templateUrl: './route-loader.component.html',
    styleUrls  : ['./route-loader.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone : true,
    imports    : [MatProgressBarModule, TranslocoModule],
})
export class RouteLoaderComponent implements OnInit, OnDestroy {
    visible = false;

    private _destroy$ = new Subject<void>();

    constructor(
        private _router: Router,
        private _cdr   : ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this._router.events
            .pipe(takeUntil(this._destroy$))
            .subscribe((event) => {
                if (event instanceof NavigationStart) {
                    this.visible = shouldShowLoader(event.url);
                    this._cdr.markForCheck();
                } else if (
                    event instanceof NavigationEnd ||
                    event instanceof NavigationCancel ||
                    event instanceof NavigationError
                ) {
                    this.visible = false;
                    this._cdr.markForCheck();
                }
            });
    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
